export var BroadcastMessageType;
(function (BroadcastMessageType) {
    BroadcastMessageType["DEFAULT"] = "text";
    BroadcastMessageType["OTN"] = "one_time_notification";
})(BroadcastMessageType || (BroadcastMessageType = {}));
